import { EnumTranslationPipe } from './enum-translation.pipe';
import { CustomFieldCompositionDto } from '@artemis-software/wr-api';
import { Pipe, PipeTransform } from '@angular/core';

const LABELS: Record<CustomFieldCompositionDto.CardinalityTypeEnum, string> = {
  Single: 'Einfach',
  Multiple: 'Mehrfach',
};

@Pipe({
  standalone: false,
  name: 'elementTypeTranslation',
})
export class ElementTypeTranslationPipe implements EnumTranslationPipe<CustomFieldCompositionDto.CardinalityTypeEnum | null | undefined>, PipeTransform {
  transform(value: CustomFieldCompositionDto.CardinalityTypeEnum | null | undefined): string {
    if (!value) {
      return '–';
    }
    const label = LABELS[value];
    if (!label) {
      console.error(`Unknown element type: ${value}`);
      return '–';
    }
    return label;
  }
}
